// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Confirm_confirm__ROyZm","confirmImg":"Confirm_confirmImg__3EwRe","confirmContent":"Confirm_confirmContent__kFS6P","confirmButtons":"Confirm_confirmButtons__1_y_c"};